import { Navigate, useLocation } from "react-router-dom";
import { isLoggedIn } from "../services/AuthService";

export type ProtectedRouteProps = {
    authenticationPath: string;
    outlet: JSX.Element;
};

export default function ProtectedRoute({authenticationPath, outlet}: ProtectedRouteProps) {
    if(isLoggedIn()) {
        return outlet;
    } else {
        return <Navigate to={{ pathname: authenticationPath }} />;
    }
};

